import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

export function externalRedirectGuard(targetUrl: string): CanActivateFn {
  return () => {
    const document = inject(DOCUMENT);
    document.location.href = targetUrl;
    return false;
  };
}
